module.exports = "/_next/static/images/pay-dinersclub-2991052e81c3899ca71ae8c6ad64bb02.svg";